import isro from "../images/isro.png";
import cb from "../images/Cb_Solution-removebg.png";

const sections = [
  {
    id: "experience1",
    image: isro,
    title: "Research Analyst Intern",
    description:
      "Engaged in a project focused on DNS resolver tech. Worked on frontend and backend development, including hands-on work with JavaScript. Contributing to enhance the way DNS queries work and provide insights about various traffic.",
    view: "https://drive.google.com/file/d/1AVjrQBxfn74wAVbJQLbDegCNb4K0xBwA/view?usp=sharing",
  },
  {
    id: "experience2",
    image: cb,
    title: "Frontend Developer",
    description:
      "Built the company’s website from scratch using React and Javascript. An informative site providing knowledge about Corpbrand’s services, their contact information along with client details.",
    view: "https://drive.google.com/file/d/1AVjrQBxfn74wAVbJQLbDegCNb4K0xBwA/view?usp=sharing",
  },
];

export default sections;
